<!--
PvcPoster
PVC海报
-->

<template>
  <transition name="el-fade-in-linear">
    <div>
      <el-collapse-item title="立牌 > PVC海报" name="PVC海报">
        <el-row>
          <el-col :span="24">
            <el-form :label-position="labelPosition" :model="pvcPoster" label-width="80px">
              <el-form-item label="形状">
                <el-select v-model="pvcPoster['形状']" placeholder="形状">
                  <el-option label="尖角" value="尖角"></el-option>
                  <el-option label="圆角" value="圆角"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="工艺">
                <el-radio-group v-model="pvcPoster['工艺']">
                  <el-radio-button label="无工艺">无工艺</el-radio-button>
                  <el-radio-button label="烫金">烫金</el-radio-button>
                  <el-radio-button label="烫银">烫银</el-radio-button>
                  <el-radio-button label="镭射银">镭射银</el-radio-button>
                  <el-radio-button label="部分透明">部分透明</el-radio-button>
                </el-radio-group>
                <div style="padding:10px"></div>
                <el-alert
                  title="其他工艺请联系客服，无工艺和部分透明部分覆膜。"
                  type="info"
                  show-icon
                  class="el-alert__title"
                  style="padding: 8px 16px; margin: 3px 0 0 0;"
                ></el-alert>
              </el-form-item>
              <el-form-item label="尺寸">
                <el-row type="flex" class="row-bg">
                  <el-col :span="12">
                    <el-input v-model="pvcPoster['尺寸宽']" placeholder="宽 cm"></el-input>
                  </el-col>
                  <el-col :span="12" :offset="0">
                    <el-input v-model="pvcPoster['尺寸长']" placeholder="长 cm"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="款式">
                <el-input v-model="pvcPoster['款式']" placeholder="请填写您选择的款式"></el-input>
              </el-form-item>
              <el-form-item label="数量" :inline="true">
                <el-input-number v-model="pvcPoster['数量']" :min="500" label="数量"></el-input-number>
                <el-alert title="单款起定数为500" type="info" show-icon class='el-alert__title' style="padding: 8px 16px; margin: 20px 0 0 0;"></el-alert>
              </el-form-item>
              <el-button v-on:click="addEvent()">提交</el-button> <el-button v-on:click="clear()">清空</el-button> 
            </el-form>
          </el-col>
        </el-row>
      </el-collapse-item>
    </div>
  </transition>
</template>
<script>
export default {
  name: "PvcPoster",
  data() {
    return {
      forcollapse: ['allsame'],
      pvcPoster: {
        title: "PVC海报",
        工艺: []
      },
      labelPosition: "left"
    };
  },
  methods: {
    addEvent() {
      this.$root.add(this.pvcPoster);
       
    },
    clear() {
      this.$root.clearAlert()
      this.pvcPoster = {
        title: "PVC海报",
        工艺: []
      };
    }
  }
};
</script>
<style scoped>
</style>